const getItem = (key) => {
  const item = localStorage.getItem(key);
  return item === "null" ? null : item;
};

export const userFinishedTutorial = () => {
  const finishedTutorial = getItem("finishedTutorial");
  return finishedTutorial === "true";
};
export const setUserFinishedTutorial = () => {
  localStorage.setItem("finishedTutorial", true);
};

export const getReferralCode = () => {
  const data = localStorage.getItem("referralCode");
  if (data === null) return null;
  const { referralCode, ts } = JSON.parse(data);
  if (Date.now() - ts > 1000 * 60 * 60 * 24 * 30) {
    console.log("referral expired!");
    return null;
  }
  console.log("got referral code", referralCode);
  return referralCode;
};
export const setReferralCode = (referralCode) => {
  const oldReferralCode = getReferralCode();
  if (oldReferralCode !== null) {
    console.log("referral code already set");
    return { isNewRef: false, referralCode: oldReferralCode };
  }
  const data = {
    referralCode,
    ts: Date.now(),
  };
  localStorage.setItem("referralCode", JSON.stringify(data));
  return { isNewRef: true, referralCode };
};
